import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionCreators from '../actions';
import firebase from '../util/firebase';
import videojs from 'video.js';
//import video from 'videojs-contrib-hls';
import GeoFire from 'geofire';

import camelCase from 'lodash/camelCase';
import differenceBy from 'lodash/differenceBy';
import Modal from 'simple-react-modal';
import RetinaImage from 'react-retina-image';

import AbstractMapView from './AbstractMapView';
import { getPorTipo, MarkerCamera, MarkerCameraOff } from '../components/mapa/Marker';

import settingsIcon from '../images/settings.png';

  
class Mosaico extends AbstractMapView {

  cameras = [];

  constructor(props) {
    super(props);
    this.state = {
      cameras: [],
      selectedCameras: [],
      bestWidth: 177,
      bestHeight: 100,
      showModal: false
    }
    this._handleWindowResize = this._handleWindowResize.bind(this);
    this._cameraDivs = [];
    this._videoPlayers = [];
    this.closeModal = this.closeModal.bind(this);
    this.handleClickCheckCamera = this.handleClickCheckCamera.bind(this);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._handleWindowResize);
    if (this.player) {
      this.player.dispose();
    }
  }

  todasCameras() {
    let user = firebase.auth().currentUser;
    const refUsersCameras = firebase.database().ref('users-cameras/' + user.uid);
    refUsersCameras.once('value', userCamerasSnap => {
      if (userCamerasSnap.val()) {
        this.loadCamerasByIds(Object.keys(userCamerasSnap.val()));
      }
    });
    const refGuardioes = firebase.database().ref('meus-guardioes/' + user.uid);
    refGuardioes.once('value', guardioesSnap => {
      if (guardioesSnap.val()) {
        let userIds = Object.keys(guardioesSnap.val());
        userIds.forEach(userId => {
          const ref = firebase.database().ref('users-cameras/' + user.uid);
          ref.once('value', userCamerasSnap => {
            this.loadCamerasByIds(Object.keys(userCamerasSnap.val()));
          });
        });
      }
    });
    const refGrupos = firebase.database().ref('meus-grupos/' + user.uid);
    refGrupos.once('value', gruposSnap => {
      if (gruposSnap.val()) {
        let groupIds = Object.keys(gruposSnap.val());
        groupIds.forEach(groupId => {
          const ref = firebase.database().ref('meus-compartilhamentos/camera/grupo/' + groupId);
          ref.once('value', camerasSnap => {
            if (camerasSnap.val()) {
              this.loadCamerasByIds(Object.keys(camerasSnap.val()));
            }
          });
        });
      }
    });
  }

  loadCamerasByIds(cameraIds) {
    console.log("cameraIds: " + JSON.stringify(cameraIds));
    cameraIds.forEach(cameraId => {
      if (this.cameras.indexOf(cameraId) == -1) {
        this.cameras.push(cameraId);
        const ref = firebase.database().ref('cameras/' + cameraId);
        ref.once('value', cameraSnap => {
          if (cameraSnap.val()) { 
            const ref = firebase.database().ref('cameras-localizacao/' + cameraSnap.key);
            ref.once('value', cameraLocationSnap => {
              if (cameraLocationSnap.val()) {
                let camera = cameraSnap.val();
                camera.key = cameraSnap.key;
                camera.coordenadas = cameraLocationSnap.val().l;
                this.setState({ 
                  cameras: [...this.state.cameras, camera] 
                });
              }
            });
          }
        });
      }
    });  
  }

  componentDidMount() {
    window.addEventListener('resize', this._handleWindowResize);
    
    this.todasCameras();
    
    setTimeout(() => {
      firebase.database().ref("cameras-mosaico/"+firebase.auth().currentUser.uid).on('value', snapshot => {
        snapshot.forEach(camera => {
          this.setState({ 
            selectedCameras: [...this.state.selectedCameras, camera.val()] 
          });
        });
        this.startVideos();
        if (this.state.selectedCameras.length == 0) {
          this.setState({
            showModal: true
          });
        }
        this.resizeCameras(window.innerWidth, window.innerHeight - 122);
      });
    }, 5000);
  }

  closeModal() {
    this.setState({
      showModal: false
    });
  }

  _handleWindowResize () {
    this.resizeCameras(window.innerWidth, window.innerHeight - 122);
  }

  isResizing = false;
  
  resizeCameras(panelWidth, panelHeight) {
    if (this.isResizing) {
      return;
    }
    this.isResizing = true;
    let nCameras = this.state.selectedCameras.length;
    let options = [];
    for (let nColumns=1; nColumns<=nCameras; nColumns++) {
      let nRows = Math.ceil(nCameras / nColumns);
      let maxWidth = Math.round(panelWidth / nColumns) - 15;
      let maxHeight = Math.round(panelHeight / nRows) - 15;
      if (!this.exceedsScreen(nColumns, nRows, maxWidth, maxWidth / 1.77, panelWidth, panelHeight)) {
        options.push({
          width: maxWidth,
          height: maxWidth / 1.77,
          nColumns: nColumns,
          nRows: nRows
        })
      }
      if (!this.exceedsScreen(nColumns, nRows, maxHeight * 1.77, maxHeight, panelWidth, panelHeight)) {
        options.push({
          width: maxHeight * 1.77,
          height: maxHeight,
          nColumns: nColumns,
          nRows: nRows
        })
      }
    }
    let bestOption = options[0];
    for (let i=0; i<options.length; i++) {
      if (options[i].width > bestOption.width) {
        bestOption = options[i];
      }
    }
    if (bestOption) {
      this.setState({
        bestWidth: bestOption.width,
        bestHeight: bestOption.height
      });
    }
    this.isResizing = false;
  }

  exceedsScreen(nColumns, nRows, width, height, panelWidth, panelHeight) {
    return nColumns * width > panelWidth || nRows * height > panelHeight;
  }
  
  registerListener() {
    // this.props.registerAlertasListeners();
    // this.props.registerCamerasListeners();
  }

  unregisterListener() {
    // this.props.unregisterAlertasListeners();
    // this.props.resetAlertas();
    // this.props.unregisterCamerasListeners();
    // this.props.resetCameras();
  }

  handleClickCheckCamera(event) {
    let checked = event.target.checked;
    let cameraId = event.target.value;
    let selectedCameras = this.state.selectedCameras;
    if (checked) {
      this.state.cameras.forEach((camera) => {
        if (camera.cameraId == cameraId) {
          selectedCameras.push(camera);
          firebase.database().ref("cameras-mosaico/"+firebase.auth().currentUser.uid+"/"+cameraId).set(camera);
        }
      });
    } else {
      this.state.selectedCameras.forEach((camera, index) => {
        if (camera.cameraId == cameraId) {
          selectedCameras.splice(index, 1);
        }
      });
      firebase.database().ref("cameras-mosaico/"+firebase.auth().currentUser.uid).child(cameraId).remove();
    }
    this.setState({ selectedCameras });
    this.startVideos();
  }

  startVideos() {
    setTimeout(() => {
      this.state.selectedCameras.forEach(camera => {
        if (this._videoPlayers[camera.cameraId]) {
          this.player = videojs(this._videoPlayers[camera.cameraId], this.props, function onPlayerReady() {
            //console.log('onPlayerReady', this)
          });
          this.player.play();
        }
      });
    }, 2000);
  }

  render() {
    return (
      <div>
        <div id="main1-map" style={{
          width: "100%", 
          height: "100%",
          backgroundColor: "#FFFFFF",
          marginTop: "5px"
        }}
          ref={ (divElement) => { this.divElement = divElement } }
        >
          { this.state.selectedCameras.map( camera => 
            <div className="video-area-1"
              key={camera.cameraId}
              style={{
                width: this.state.bestWidth+5,
                height: this.state.bestHeight+2,
                backgroundColor: "#FFFFFF"
              }}
            >
              <div  
                key={camera.videoUrl}
                ref={node => {
                  if (node !== null) {
                    this._cameraDivs[camera.cameraId] = node;
                  }
                }}
                style={{
                  width: this.state.bestWidth,
                  height: this.state.bestHeight,
                  paddingLeft: "1px"
                }}
                data-vjs-player
              >
                <video width="352" height="198" controls muted="muted"
                  ref={node => {
                    if (node !== null) {
                      this._videoPlayers[camera.cameraId] = node;
                    }
                  }}
                  className="video-js"
                >
                  <source src={camera.videoUrl} />
                </video>
              </div>
            </div>
          )}
        </div>
        <Modal show={this.state.showModal == true} onClose={this.closeModal}>
          <br></br>
          { this.state.cameras.map((camera) => 
            <p key={camera.cameraId}>
              <input type="checkbox" onClick={this.handleClickCheckCamera} value={camera.cameraId}
                checked={this.state.selectedCameras.filter(selectedCamera => selectedCamera.cameraId === camera.cameraId).length > 0} >
              </input>{camera.name}
            </p>
          )}
        </Modal>
        <button style={{
            position: 'absolute',
            bottom:0,
            right:10,
            border: 'none',
            color: 'white',
            padding: '10px',
            display: 'inline-block',
            background: window.whiteLabel.actionColor,
            margin: '4px 2px',
            cursor: 'pointer',
            borderRadius: '100%'
          }}
            onClick={() => this.setState({ showModal: true }) }  
          >
            <RetinaImage className="header-logo" src={settingsIcon} width="30px" />
          </button>
      </div>
    );
  }

  

  updateMarkersLayer(nextProps) {        
    this.markerLayers.removeLayers(this.markerLayers.getLayers())
    const { filtroAlertas } = nextProps;

    nextProps.cameras
      .sort((a, b) => a.key.localeCompare(b.key))
      .forEach(camera => {
        const id = camera.key;
        camera.id = id;

        const marker = (camera.state === "offline") ? MarkerCameraOff : MarkerCamera;
        
        this.markerLayers.addLayer(
          marker(camera.coordenadas, camera, undefined, camera => this.onClickCamera(camera, nextProps))
        );
      });
    
    const isPulse     = layer => layer.options.id === 'pulse-marker';
    const isTipo      = alerta => {
      var data = new Date();
      switch(filtroAlertas){
        case '1h':
          var filtro1h = data.setHours(data.getHours() - 1);
          if(alerta.timestamp > filtro1h/1000 | 0){
            return alerta;
          }
        break;
        case '24h':
          var filtro24h = data.setHours(data.getHours() - 24);
          if(alerta.timestamp > filtro24h/1000 | 0){
            return alerta;
          }
        break;
        case 'todos':
          return alerta;
        default:
          if(camelCase(filtroAlertas) === camelCase(alerta.tipo)){
            return alerta;
          }
      }
    }
    
    const alertas = nextProps.alertas.filter(alerta => isTipo(alerta));;
    const alertasAnteriores = this.markerLayers.getLayers().filter(m => !isPulse(m)).map(m => m.options.alerta);
    const entraram = differenceBy(alertas, alertasAnteriores, 'id');

    entraram.forEach(alerta => {
      this.markerLayers.addLayer(getPorTipo(alerta.tipo,alerta.localizacao, {id: alerta.id, alerta, endereco: alerta.endereco}, alerta.usuario));
    });

  }

  componentWillReceiveProps(nextProps) {
    // return super.componentWillReceiveProps(nextProps)
    //   .then(() => {
    //     const toastAlerta = nextProps.toastAlertaSelecionado.coordenadas;
    //     if (toastAlerta) {
    //       this.map.flyTo(new LatLng(toastAlerta[0], toastAlerta[1]), 18);
    //     }
    //   });
  }

}




const mapStateToProps = (state) =>  ({
  cameras: state.cameras,
  cameraSelecionada: state.cameraSelecionada,
  toastAlertaSelecionado: state.alertaToastSelecionado,
  alertas: state.alertas,
  filtroAlertas: state.filtroAlertas,
  videoUrl: state.videoUrl,
  raio: state.raio,
  localizacao: state.localizacao
});
const mapDispatchToProps = (dispatch) => bindActionCreators(actionCreators, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Mosaico);



// WEBPACK FOOTER //
// ./src/containers/Mosaico.js